import { FeatherIcon } from './FeatherIcon';

interface MenuTabProps {
  className: string;
  pillClassName: string;
  labelClassName?: string;
  label: string;
  open: boolean;
  /** Highlighted as the current tab. */
  current: boolean;
  onToggle: () => void;
}

/** The Menu tab of a phone tab bar: opens and closes the shell's menu drawer.
 *  The shell's bar (Layout) and the CRM tab bar (CrmMobileTabs) both carry it. */
export function MenuTab({ className, pillClassName, labelClassName, label, open, current, onToggle }: MenuTabProps) {
  return (
    <button type="button" className={`${className} ${current ? 'is-on' : ''}`} onClick={onToggle} aria-expanded={open}>
      <span className={pillClassName}>
        <FeatherIcon name={open ? 'x' : 'menu'} size={20} />
      </span>
      <span className={labelClassName}>{label}</span>
    </button>
  );
}
